module.exports = __webpack_public_path__ + "img/lipeilong.9ed66e12.jpg";